import { render, staticRenderFns } from "./PowerpageInputFields.vue?vue&type=template&id=28efbf24&"
import script from "./PowerpageInputFields.vue?vue&type=script&lang=js&"
export * from "./PowerpageInputFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports